import { Configuration, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import config from "config/config";

const createMsalConfig = (clientId: string | undefined, tenantId: string | undefined): Configuration => ({
  auth: {
    clientId: clientId || "",
    authority: `https://login.microsoftonline.com/${tenantId}`,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        if (level <= LogLevel.Info) {
          console.log(message);
        }
      },
      piiLoggingEnabled: false,
    },
  },
});

export const internalMsalConfig: Configuration = createMsalConfig(
  config.internalEntraClientId,
  config.azureTenantId
);

export const externalMsalConfig: Configuration = createMsalConfig(
  config.externalEntraClientId,
  'common'
);

// Use the internal client ID as the scope to get token for your own API
export const scopes = (application: PublicClientApplication) => [application.getConfiguration().auth.clientId + "/.default"];

// Singleton MSAL instance for internal users
export const internalMsalInstance = new PublicClientApplication(internalMsalConfig);

// Singleton MSAL instance for external users
export const externalMsalInstance = new PublicClientApplication(externalMsalConfig);

// Initialize both instances
let internalInitialized = false;
let externalInitialized = false;

export const initializeInternalMsal = async () => {
  if (!internalInitialized) {
    await internalMsalInstance.initialize();
    internalInitialized = true;
    console.debug("Internal MSAL instance initialized");
  }
  return internalMsalInstance;
};

export const initializeExternalMsal = async () => {
  if (!externalInitialized) {
    await externalMsalInstance.initialize();
    externalInitialized = true;
    console.debug("External MSAL instance initialized");
  }
  return externalMsalInstance;
};
